(function(){
  /* Barra fija de compra en telefono.
     Patron de tiendas grandes: miniatura + nombre en dos lineas + variante y precio + boton.
     Arreglos que se conservan de versiones anteriores:
     - se vuelve a evaluar al rotar el telefono (antes se decidia una sola vez al cargar)
     - refleja el estado real del boton: si la pieza esta agotada no dice "Agregar"
     - marca aria-hidden cuando no se ve, para que el lector de pantalla no la lea dos veces
     - le pone una clase al body para que la barra no tape el final de la pagina
     Nuevo en esta version:
     - miniatura cuadrada tomada de la imagen activa de la galeria
     - nombre acortado (quita "Prosperidad" y "Recubrimiento PVD de", conserva el color) para que quepa en 2 lineas
     - linea de variante (talla o largo) y precio, con el precio de lista tachado si hay oferta
     - todo se actualiza cuando el cliente cambia de talla o largo */
  var MOVIL = 749, bar = null, io = null, temporizador, observado = null;

  function raiz(){
    return document.querySelector('product-info') || document;
  }
  function botonReal(){
    return document.querySelector('product-form .product-form__submit')
        || document.querySelector('.product-form__submit');
  }
  function tituloCompleto(){
    var t = raiz().querySelector('.product__title h1') || document.querySelector('.product__title h1')
         || raiz().querySelector('.product__title') || document.querySelector('.product__title');
    return t ? t.textContent.trim().replace(/\s+/g, ' ') : '';
  }
  function tituloCorto(titulo){
    if(!titulo || titulo.indexOf('Recubrimiento PVD de') === -1) return titulo;
    var partes = titulo.split('Recubrimiento PVD de');
    var base = partes[0].replace(/\bProsperidad\b/i, '').replace(/\s+/g, ' ').trim();
    var color = (partes[1] || '').replace(/\s+/g, ' ').trim();
    return color ? (base + ' · ' + color) : base;
  }
  function cajaPrecio(){
    return raiz().querySelector('.price') || document.querySelector('.price');
  }
  function preciosReales(){
    var caja = cajaPrecio();
    if(!caja) return { venta: '', lista: '' };
    var venta = '', lista = '';
    if(caja.classList.contains('price--on-sale')){
      var v = caja.querySelector('.price__sale .price-item--sale');
      var l = caja.querySelector('.price__sale .price-item--regular');
      venta = v ? v.textContent.trim() : '';
      lista = l ? l.textContent.trim() : '';
    } else {
      var vr = caja.querySelector('.price__regular .price-item--regular');
      venta = vr ? vr.textContent.trim() : '';
    }
    if(!venta){
      var cualquiera = caja.querySelector('.price-item--sale') || caja.querySelector('.price-item--regular') || caja.querySelector('.price-item');
      venta = cualquiera ? cualquiera.textContent.trim() : '';
    }
    return { venta: venta, lista: lista };
  }
  function varianteTexto(){
    var radio = document.querySelector('variant-radios input[type="radio"]:checked, .product-form input[type="radio"]:checked, fieldset input[type="radio"]:checked');
    if(radio) return radio.value;
    var selects = document.querySelectorAll('variant-selects select, .product-form select');
    if(selects.length) return selects[selects.length - 1].value;
    return '';
  }
  function imagenActual(){
    var img = document.querySelector('.product__media-item.is-active img')
           || document.querySelector('[data-media-id] img')
           || document.querySelector('.product__media img');
    if(!img) return '';
    var src = img.currentSrc || img.src || img.getAttribute('src') || '';
    if(!src) return '';
    if(src.indexOf('//') === 0) src = 'https:' + src;
    src = src.split('?')[0];
    return src + '?width=96';
  }

  function reengancharObservador(real){
    /* Dawn a veces re-arma el boton real via AJAX al cambiar de talla/largo;
       si eso pasa, el nodo que el IntersectionObserver vigilaba desaparece
       y la barra se queda pegada en su ultimo estado. Aqui se vuelve a
       enganchar al boton vigente para que la barra siga respondiendo al scroll. */
    if(!io || !real || observado === real) return;
    io.disconnect();
    io.observe(real);
    observado = real;
  }

  function sincronizar(){
    var real = botonReal();
    if(!bar || !real) return;
    reengancharObservador(real);
    var precios = preciosReales();
    bar.querySelector('.lx-sa-price').textContent = precios.venta;
    var listaEl = bar.querySelector('.lx-sa-compare');
    listaEl.textContent = precios.lista;
    listaEl.hidden = !precios.lista;
    var variante = varianteTexto();
    var varEl = bar.querySelector('.lx-sa-variant');
    varEl.textContent = variante;
    varEl.hidden = !variante;
    var img = imagenActual();
    var imgEl = bar.querySelector('.lx-sa-thumb');
    if(img && imgEl.getAttribute('src') !== img) imgEl.src = img;
    var btn = bar.querySelector('.lx-sa-btn');
    btn.disabled = !!real.disabled;
    btn.textContent = real.disabled ? 'Agotado' : 'Agregar';
  }

  function montar(){
    var real = botonReal();
    if(!real || bar) return;
    var titulo = tituloCorto(tituloCompleto());
    bar = document.createElement('div');
    bar.className = 'lx-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
        '<img class="lx-sa-thumb" alt="" width="48" height="48">'
      + '<div class="lx-sa-info">'
      +   '<span class="lx-sa-title"></span>'
      +   '<span class="lx-sa-meta">'
      +     '<span class="lx-sa-variant" hidden></span>'
      +     '<span class="lx-sa-price"></span>'
      +     '<span class="lx-sa-compare" hidden></span>'
      +   '</span>'
      + '</div>'
      + '<button type="button" class="button lx-sa-btn">Agregar</button>';
    bar.querySelector('.lx-sa-title').textContent = titulo;
    var img = imagenActual();
    if(img) bar.querySelector('.lx-sa-thumb').src = img;
    document.body.appendChild(bar);
    document.body.classList.add('lx-con-sticky');
    bar.querySelector('.lx-sa-btn').addEventListener('click', function(){
      var r = botonReal(); if(r && !r.disabled) r.click();
    });
    sincronizar();
    if('IntersectionObserver' in window){
      io = new IntersectionObserver(function(entradas){
        var fuera = !entradas[0].isIntersecting;
        bar.classList.toggle('is-visible', fuera);
        bar.setAttribute('aria-hidden', fuera ? 'false' : 'true');
      }, {rootMargin: '0px 0px -120px 0px'});
      io.observe(real);
      observado = real;
    }
  }

  function desmontar(){
    if(!bar) return;
    if(io){ io.disconnect(); io = null; }
    observado = null;
    bar.remove(); bar = null;
    document.body.classList.remove('lx-con-sticky');
  }

  function evaluar(){ if(window.innerWidth <= MOVIL) montar(); else desmontar(); }

  function init(){
    if(!botonReal()) return;
    evaluar();
    window.addEventListener('resize', function(){
      clearTimeout(temporizador); temporizador = setTimeout(evaluar, 200);
    });
    document.addEventListener('change', function(e){
      if(e.target.closest('product-form, variant-selects, variant-radios, .product-form')) setTimeout(sincronizar, 300);
    });
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
